import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Dygraph from '@qogni/dygraphs';

var NoWarningRangeSelector = /*#__PURE__*/function (_Dygraph$Plugins$Rang) {
  _inherits(NoWarningRangeSelector, _Dygraph$Plugins$Rang);

  var _super = _createSuper(NoWarningRangeSelector);

  function NoWarningRangeSelector() {
    var _thisSuper, _this;

    _classCallCheck(this, NoWarningRangeSelector);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.computeCombinedSeriesAndLimits_ = function () {
      if (_this.dygraph_.numColumns() === 0) {
        return {
          data: [],
          yMin: Number.MAX_VALUE,
          yMax: -Number.MAX_VALUE
        };
      }

      return _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(NoWarningRangeSelector.prototype)), "computeCombinedSeriesAndLimits_", _thisSuper).call(_thisSuper);
    }, _temp));
  }

  return NoWarningRangeSelector;
}(Dygraph.Plugins.RangeSelector);

export { NoWarningRangeSelector as default };